import type { BooleanFeatureFlag } from './booleanFlags';
import { useBooleanLaunchDarklyFlag_internalDontUse } from './launchDarkly';

export const useFeatureFlagEnabledBoolean = (
  feature: BooleanFeatureFlag,
): boolean => useBooleanLaunchDarklyFlag_internalDontUse(feature);
